"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var Typename_1 = require("../../types/enums/Typename");
var dayjs_1 = __importDefault(require("dayjs"));
var constants_1 = require("./constants");
var selectors_1 = require("../customer/selectors");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
exports.parentalSettings = reselect_1.createSelector(moduleState, function (state) { return state.parentalSettings.data; });
exports.isLoading = reselect_1.createSelector(moduleState, function (state) { return state.parentalSettings.isLoading; });
exports.parentalPinValidation = reselect_1.createSelector(moduleState, selectors_1.selectedProfileId, function (state, profileId) {
    return profileId && state.parentalPinValidation.data[profileId];
});
exports.parentalControl = reselect_1.createSelector(exports.parentalSettings, function (settings) { return settings === null || settings === void 0 ? void 0 : settings.parentalControl; });
exports.approvedClassification = reselect_1.createSelector(exports.parentalSettings, function (settings) { return settings === null || settings === void 0 ? void 0 : settings.approvedClassification; });
exports.pinValidationStatus = reselect_1.createSelector(exports.parentalSettings, function (settings) { return settings === null || settings === void 0 ? void 0 : settings.pinValidationStatus; });
exports.pinValidationResult = reselect_1.createSelector(exports.parentalPinValidation, function (pinValidation) { var _a; return (_a = pinValidation) === null || _a === void 0 ? void 0 : _a.pinValidationResult; });
exports.isLoadingValidation = reselect_1.createSelector(moduleState, function (state) { var _a; return (_a = state.parentalPinValidation) === null || _a === void 0 ? void 0 : _a.isLoading; });
exports.validationError = reselect_1.createSelector(moduleState, function (state) { var _a; return (_a = state.parentalPinValidation) === null || _a === void 0 ? void 0 : _a.error; });
exports.parentalSettingsError = reselect_1.createSelector(moduleState, function (state) { var _a; return (_a = state.parentalSettings) === null || _a === void 0 ? void 0 : _a.error; });
exports.pinExpiry = reselect_1.createSelector(exports.parentalPinValidation, function (pinValidation) {
    if (pinValidation) {
        var result = pinValidation.pinValidationResult, expiryDate = pinValidation.expiryDate;
        if (result.__typename === Typename_1.Typename.PinValidationResult && (result === null || result === void 0 ? void 0 : result.isValid)) {
            return expiryDate;
        }
    }
    return undefined;
});
exports.hasPinExpired = function (date) {
    return date ? dayjs_1.default().isAfter(date) : true;
};
//# sourceMappingURL=selectors.js.map